import { render, staticRenderFns } from "./zDelete.vue?vue&type=template&id=7040e080&scoped=true&"
import script from "./zDelete.vue?vue&type=script&setup=true&lang=js&"
export * from "./zDelete.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7040e080",
  null
  
)

export default component.exports